import styled from 'styled-components';

import { apx, colors, px, fontFamilySize } from '../../../../contrib/ui';

export const PlayersRosterStyled = styled.div`
  .main-grid-container {
    margin-bottom: ${apx(10)};

    .add-players-card--player-groups.override {
      width: auto;
      margin: ${apx(10)};
    }

    .paper.player-list-paper {
      min-height: 90%;

      .section-selector {
        width: 70%;
        display: flex;
        flex-direction: row;
        align-items: center;

        button {
          .pending-chip {
            margin-left: ${px(10)};
            width: 30px;
            height: 30px;

            span {
              ${fontFamilySize('Bold', 14)}
              padding-left: 0;
              color: ${colors.red};
              padding-right: 0;
            }
          }

          &.button--disabled {
            color: ${colors.grey9b};

            .pending-chip span {
              color: ${colors.grey9b};
            }
          }
        }
      }
    }
  }

  .paper {
    width: auto;
    margin: ${apx(10)};
  }

  .bot-16 {
    margin-bottom: ${apx(6)};
    font-family: 'DINNextLTPro-Heavy';
    font-size: ${apx(22)};
    line-height: ${apx(26)};
    text-align: center;
    color: var(--dark);
    border-bottom: 0;
    padding-bottom: 0;
  }

  .player-list-paper.override {
    padding: 0;
    border-radius: calc(var(--px) * 5);
    overflow: hidden;
  }

  .paper-player {
    display: flex;
    width: 100%;
    height: 100%;
    margin-bottom: 0;
    padding: 0 ${apx(12)};
    border: 0;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid var(--greydd);

    &.black {
      align-items: center;
      background-color: var(--dark);
      color: #fff;
      font-family: 'DINNextLTPro-bold';
      font-size: ${apx(16)};
      line-height: ${apx(26)};
      height: ${apx(50)};
      border-radius: 0;

      .title-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .title-item {
          display: flex;
          align-items: center;
          background-color: var(--dark);
          color: #fff;
          font-family: 'DINNextLTPro-bold';
          font-size: ${apx(16)};
          line-height: ${apx(26)};

          &.select {
            width: ${apx(60)};
          }

          &.firstname {
            margin-left: ${apx(12)};
            width: 10em;
          }

          &.lastname {
            margin-left: auto;
            margin-right: auto;
          }

          &.index {
            margin-left: 1em;
          }

          &.ghin {
            margin-left: auto;
          }

          &.ghin,
          &.index {
            width: ${apx(100)};
            text-align: center;
            display: block;
            overflow: hidden;
            margin-right: 0;
            text-overflow: ellipsis;
          }

          & > * {
            & > * {
              color: var(--mainColor);
              width: ${apx(20)};
              height: ${apx(16)};
              margin-left: ${apx(5)};
            }
          }
        }
      }
    }

    & > label {
      width: 100%;
      margin-right: 0;
      margin-left: 0;

      & > span {
        &:not(:first-child) {
          width: 100%;
        }
      }
    }

    .player-row {
      align-items: center;
      color: var(--grey4a);
      display: flex;
      flex-direction: row;
      font-family: 'DINNextLTPro-bold';
      font-size: ${apx(16)};
      justify-content: space-between;
      padding-left: ${apx(12)};
      padding-right: ${apx(0)};
      text-align: left;
      width: 100%;

      .player-item {
        display: flex;
        align-items: center;

        .group-action-icon {
          width: ${apx(30)};
          height: ${apx(30)};
        }

        &.firstname {
          width: 10em;
        }

        &.lastname {
          margin-left: 6%;
          margin-right: auto;
        }

        &.index {
          margin-left: 1em;
        }

        &.ghin {
          margin-left: auto;
        }

        &.ghin,
        &.index {
          width: ${apx(100)};
          text-align: center;
          display: block;
          overflow: hidden;
          margin-right: 0;
          text-overflow: ellipsis;
        }

        .user-pic {
          margin-right: ${apx(8)};
          width: ${apx(36)};
          height: ${apx(36)};
          border-radius: ${apx(18)};
        }
      }
    }
  }
`;
